import { getMultidietSetup } from '../get-multidiet-setup';
import {
  MultidietSetupParamsType,
  MultidietSetupType,
} from '@/features/multidiet-picker/types/multidiet-setup.type';
import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';

type UseMultidietSetupParams = {
  params?: RequestInit;
  queryParams?: MultidietSetupParamsType;
  options?: Omit<
    UseQueryOptions<MultidietSetupType, unknown, MultidietSetupType, string[]>,
    'queryFn' | 'queryKey'
  >;
};

export const useMultidietSetup = ({
  params,
  queryParams,
  options,
}: UseMultidietSetupParams) => {
  return useQuery({
    queryKey: ['multidiet-setup', JSON.stringify(queryParams)],
    queryFn: () => getMultidietSetup({ params, queryParams }),
    ...options,
  });
};
